import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import UserSearch from './pages/UserSearch';
import UserDetail from './pages/UserDetail';
import AuditLog from './pages/AuditLog';
import Activity from './pages/Activity';
import PhoneReputation from './pages/PhoneReputation';
import PromoCodes from './pages/PromoCodes';
import FeatureFlags from './pages/FeatureFlags';
import Waitlist from './pages/Waitlist';
import SystemHealth from './pages/SystemHealth';
import FTCData from './pages/FTCData';
import Senders from './pages/Senders';
import Financials from './pages/Financials';
import Training from './pages/Training';
import Feedback from './pages/Feedback';
import SetupTOTP from './pages/SetupTOTP';
import SupportLine from './pages/SupportLine';
import Voicemails from './pages/Voicemails';
import ReleaseNotes from './pages/ReleaseNotes';
import CampaignLinks from './pages/CampaignLinks';

const theme = createTheme({
  palette: {
    primary: {
      main: '#7c3aed',
    },
    secondary: {
      main: '#ec4899',
    },
    background: {
      default: '#f8fafc',
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 500,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
    MuiContainer: {
      styleOverrides: {
        root: {
          '@media (max-width: 600px)': {
            paddingLeft: 12,
            paddingRight: 12,
          },
        },
      },
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Layout>
                    <Dashboard />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/users"
              element={
                <ProtectedRoute>
                  <Layout>
                    <UserSearch />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/users/:userId"
              element={
                <ProtectedRoute>
                  <Layout>
                    <UserDetail />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/activity"
              element={
                <ProtectedRoute>
                  <Layout>
                    <Activity />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/audit-log"
              element={
                <ProtectedRoute>
                  <Layout>
                    <AuditLog />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/phone-reputation"
              element={
                <ProtectedRoute>
                  <Layout>
                    <PhoneReputation />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/promo-codes"
              element={
                <ProtectedRoute>
                  <Layout>
                    <PromoCodes />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/feature-flags"
              element={
                <ProtectedRoute>
                  <Layout>
                    <FeatureFlags />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/waitlist"
              element={
                <ProtectedRoute>
                  <Layout>
                    <Waitlist />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/system-health"
              element={
                <ProtectedRoute>
                  <Layout>
                    <SystemHealth />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/ftc-data"
              element={
                <ProtectedRoute>
                  <Layout>
                    <FTCData />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/senders"
              element={
                <ProtectedRoute>
                  <Layout>
                    <Senders />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/financials"
              element={
                <ProtectedRoute>
                  <Layout>
                    <Financials />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/training"
              element={
                <ProtectedRoute>
                  <Layout>
                    <Training />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/feedback"
              element={
                <ProtectedRoute>
                  <Layout>
                    <Feedback />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/security"
              element={
                <ProtectedRoute>
                  <Layout>
                    <SetupTOTP />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/support-line"
              element={
                <ProtectedRoute>
                  <Layout>
                    <SupportLine />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/voicemails"
              element={
                <ProtectedRoute>
                  <Layout>
                    <Voicemails />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/release-notes"
              element={
                <ProtectedRoute>
                  <Layout>
                    <ReleaseNotes />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/campaign-links"
              element={
                <ProtectedRoute>
                  <Layout>
                    <CampaignLinks />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;